
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.234.78a2.602 2.602 0 00-2.7-.64L1.798 4.396a2.61 2.61 0 00-.108 4.922l4.716 1.8a.836.836 0 01.477.467l1.8 4.723A2.583 2.583 0 0011.124 18h.063a2.593 2.593 0 002.42-1.8l4.258-12.749a2.599 2.599 0 00-.63-2.672zM16.2 2.884l-4.302 12.758a.792.792 0 01-.756.558.828.828 0 01-.783-.522l-1.8-4.724a2.618 2.618 0 00-1.504-1.511l-4.725-1.8a.81.81 0 01-.53-.783.792.792 0 01.557-.755L15.12 1.85a.82.82 0 011.08 1.035z","fill":"#D8F3DC"}})])
          )
        }
      }
    